var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import SheetFooterStyle from './SheetFooterStyle.js';
/**
 * SheetFooter component.
 */
export default class SheetFooter extends KompisElement {
    /**
     * Renders the component.
     *
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${SheetFooterStyle.getStyle({
            theme: this.theme
        })}
			</style>
			<div class="container">
				<slot></slot>
			</div>
		`;
    }
}
__decorate([
    property({ type: Object, required: true })
], SheetFooter.prototype, "theme", void 0);
//# sourceMappingURL=SheetFooter.js.map